import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import "./Navbar.css";
import logo from "../../assets/images/log3.png";

const Navbar: React.FC = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    setIsMenuOpen(false);
  }, [location]);

  return (
    <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/" className="navbar-logo" style={{marginRight: '1.5rem', display: 'flex', alignItems: 'center'}}>
          <img
            src={logo}
            alt="Has Gümüş  Logo"
            className="navbar-logo-image"
          />
        </Link>
        {/* Menü */}
        <div className={`navbar-menu ${isMenuOpen ? "menu-open" : ""}`} style={{flex: 1}}>
          <ul className="menu">
            <li>
              <Link
                to="/"
                className={`menu-item ${location.pathname === "/" ? "active" : ""}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Ana Sayfa
              </Link>
            </li>
            <li>
              <Link
                to="/bilgitoplum"
                className={`menu-item ${location.pathname === "/bilgitoplum" ? "active" : ""}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Bilgi Toplumu Hizmetleri
              </Link>
            </li>
            <li>
              <Link
                to="/products"
                className={`menu-item ${location.pathname === "/products" ? "active" : ""}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Uyum
              </Link>
            </li>
            <li>
              <Link
                to="/about"
                className={`menu-item ${location.pathname === "/about" ? "active" : ""}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Hakkımızda
              </Link>
            </li>
            <li>
              <Link
                to="/contact"
                className={`menu-item ${location.pathname === "/contact" ? "active" : ""}`}
                onClick={() => setIsMenuOpen(false)}
              >
                İletişim
              </Link>
            </li>
          </ul>
        </div>
        {/* Sağ tarafta iletişim numarası ve menü butonu */}
        <div className="navbar-right">
          <a href="tel:02125185050" className="navbar-phone" aria-label="Telefon: 0212 518 50 50">
            <span className="navbar-phone-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" width="16" height="16" focusable="false" aria-hidden="true">
                <path
                  fill="currentColor"
                  d="M6.62 10.79a15.05 15.05 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.02-.24c1.12.37 2.33.57 3.57.57a1 1 0 0 1 1 1V20a1 1 0 0 1-1 1C10.07 21 3 13.93 3 5a1 1 0 0 1 1-1h3.5a1 1 0 0 1 1 1c0 1.24.2 2.45.57 3.57a1 1 0 0 1-.24 1.02l-2.2 2.2Z"
                />
              </svg>
            </span>
            <span className="navbar-phone-text">0212 518 50 50</span>
          </a>
          <button
            className="menu-toggle"
            onClick={toggleMenu}
            aria-label="Toggle navigation menu"
            style={{marginLeft: '0.3rem'}}
          >
            {isMenuOpen ? "✖" : "☰"}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
